import React, { useState } from "react";
import { getDate } from "utils/formatDate";
import { BtnChiTietKhachHang } from "../DanhSachKhachHang/ChiTietKhachHang/BtnChiTietKhachHang";
import { ModalImage } from "./ModalImage";

const defaultDebtLevelStyle = { text: "Bình Thường", style: { color: '#008CFF', backgroundColor: '#DCEEFF', padding: '2px 8px', borderRadius: '4px' } };

const getDebtLevelInfo = (debtLevelCode, listTinhTrang) => {
    const status = listTinhTrang.find(s => s.value == debtLevelCode);
    if (!status) return defaultDebtLevelStyle;

    let style = {};
    const ten = status.label.toLowerCase();
    if (ten.includes("bình thường")) {
        style = { color: '#00B699', backgroundColor: '#CCF0EB', padding: '2px 8px', borderRadius: '4px' };
    } else if (ten.includes("rủi ro") || ten.includes("r3") || ten.includes("r2")) {
        style = { color: '#FF5C00', backgroundColor: '#FFEBC6', padding: '2px 8px', borderRadius: '4px' };
    } else if (ten.includes("nợ xấu")) {
        style = { color: '#FF5170', backgroundColor: '#FFD8D8', padding: '2px 8px', borderRadius: '4px' };
    }
    return { text: status.label, style: style };
};

const StatusBadge = ({ text, style }) => {
    return <span style={style}>{text}</span>;
};

const defaultAvatar = "/app-assets/images/no_image.png";

export const ContentTable = ({
    listDanhSach,
    dataSearch,
    listTinhTrang,
    listCuaHang,
    selectedCustomer,
    setSelectedCustomer
}) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const handleShowImage = (imageUrl) => setSelectedImage(imageUrl);
    const handleCloseImage = () => setSelectedImage(null);

    if (!listDanhSach || listDanhSach.length === 0) {
        return (
            <div className="custom-table-row no-data" style={{ minHeight: 56, justifyContent: 'center' }}>
                <div className="custom-table-cell text-center red" style={{ width: "100%", border: 'none' }}>
                    Không có dữ liệu
                </div>
            </div>
        );
    }
    const formatPhoneNumber = (input) => {
        try {
            if (!input) return "";
            const str = input.split(';')[0].trim();
            if (str.length === 10) return str.replace(/(\d{4})(\d{3})(\d{3})/, "$1.$2.$3");
            if (str.length === 11) return str.replace(/(\d{4})(\d{3})(\d{4})/, "$1.$2.$3");
            return str;
        } catch (e) { return input; }
    }

    const pageStartIndex = (dataSearch.pageIndex - 1) * dataSearch.pageSize;

    return (
        <>
            {listDanhSach.map((item, index) => {
                const statusInfo = getDebtLevelInfo(item.DebtLevel, listTinhTrang);
                const cuaHang = listCuaHang.find(ch => ch.value === item.DBName);
                const imageUrl = item.Img || defaultAvatar;
                const isDefaultAvatar = imageUrl === defaultAvatar;
                const tenCuaHang = cuaHang ? cuaHang.label : (item.DBName ? item.DBName.replace("QLTC_", "") : "N/A");
                const isSelected = selectedCustomer && (selectedCustomer.CustomerID === item.CustomerID) && (selectedCustomer === item);

                return (
                    <div
                        key={item.CustomerID}
                        className={`custom-table-row ${isSelected ? 'active-row' : ''}`}
                        style={{
                            minHeight: "50px",
                            cursor: 'pointer',
                            backgroundColor: isSelected ? '#edfcf3' : ''
                        }}
                        onClick={() => setSelectedCustomer(item)}
                    >
                        <div className="custom-table-cell flex-basis-7 flex-basis-7-sm" style={{ fontSize: "15px", fontWeight: 500 }}>
                            <span className="mobile-column-name">STT</span>
                            <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                                {pageStartIndex + index + 1}
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-16 flex-basis-16-sm" style={{ fontSize: "15px", fontWeight: 500 }}>
                            <span className="mobile-column-name">Tên khách hàng</span>
                            <div className="center-wrapper word-break " style={{ justifyContent: 'flex-start' }}>
                                <div className="text-info-new" style={{ color: 'inherit', cursor: 'pointer' }} onClick={(e) => e.stopPropagation()}>
                                    <BtnChiTietKhachHang item={item} /> <br /> {formatPhoneNumber(item.Phone)}
                                </div>
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-14 flex-basis-14-sm" style={{ fontSize: "15px", fontWeight: 500 }}>
                            <span className="mobile-column-name">Cửa hàng</span>
                            <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                                {tenCuaHang}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-8 flex-basis-8-sm" style={{ fontSize: "15px", fontWeight: 500 }}>
                            <span className="mobile-column-name">Ngày sinh</span>
                            <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                                {item.Birthday ? getDate(item.Birthday) : ""}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm" style={{ fontSize: "15px", fontWeight: 500 }}>
                            <span className="mobile-column-name">Số CCCD</span>
                            <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                                {item.CMT}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-15 flex-basis-15-sm" style={{ fontSize: "15px", fontWeight: 500 }}>
                            <span className="mobile-column-name">Địa chỉ</span>
                            <div className="center-wrapper word-break text-left" style={{justifyContent: 'flex-start'}}>
                                {item.Address}
                            </div>
                        </div>

                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm" style={{fontSize: "15px", fontWeight: 500 }}>
                            <span className="mobile-column-name">Đối tác</span>
                            <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                                {item.IsCus ? "Khách hàng" : "Chủ nợ"}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm" style={{ fontSize: "15px", fontWeight: 500 }}>
                            <span className="mobile-column-name">Tình trạng</span>
                            <div className="center-wrapper word-break text-center" style={{justifyContent: 'center'}}>
                                <StatusBadge text={statusInfo.text} style={statusInfo.style} />
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm" style={{  fontSize: "15px", fontWeight: 500 }}>
                            <div className="center-wrapper word-break text-center" style={{ display: "flex", justifyContent: 'center', width: '100%' }}>
                                <img
                                    src={imageUrl}
                                    style={{
                                        width: '100%',
                                        maxWidth: '80px',
                                        aspectRatio: '1 / 1',
                                        height: 'auto',
                                        objectFit: 'cover',
                                        borderRadius: '4px',
                                        display: 'block',
                                        cursor: isDefaultAvatar ? 'default' : 'pointer'
                                    }}
                                    onClick={(e) => {
                                        if (!isDefaultAvatar) {
                                            e.stopPropagation();
                                            handleShowImage(imageUrl);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
            <ModalImage
                show={selectedImage !== null}
                onHide={handleCloseImage}
                imageUrl={selectedImage}
                imageTitle="Xem ảnh đại diện"
            />
        </>
    );
};